import { render, staticRenderFns } from "./TsdAccount.vue?vue&type=template&id=d71804b8&"
import script from "./TsdAccount.vue?vue&type=script&lang=js&"
export * from "./TsdAccount.vue?vue&type=script&lang=js&"
import style0 from "./TsdAccount.vue?vue&type=style&index=0&id=d71804b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports